import { Zap } from 'lucide-react';

import { Label } from '@crossnokaye/ux-common';

import { AtlasRouteIds } from '@/components/navigation/constants';
import { NavLink } from '@/components/navigation/nav-link';
import { Icon } from '@/ux-common/components/icon';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from '@/ux-common/components/tooltip/tooltip';

export const EaiBadge = () => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={'cursor-pointer'}>
          <NavLink routeId={AtlasRouteIds.EnergyAI}>
            {/* The CKDS icon token built for this badge — resolves to
              --ckds-eai-500 (#C300FF) in both themes. */}
            <Icon className="icon-sm bg-ckds-icon-bg-eai" data-testid="EAI-badge">
              <Zap className="glyph glyph-sm fill-white" aria-hidden="true" />
            </Icon>
          </NavLink>
        </div>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          className={'flex flex-col gap-2 items-start justify-start text-left w-[19rem]'}
        >
          <Label className={'font-bold'}>{'High Rate Load Shedding Active'}</Label>
          <Label>
            {
              'Current utility rates are high. Evaporator temperatures will briefly rise to shed load.'
            }
            {'The purple icon will disappear when rates and temperatures return to normal.'}
          </Label>
          <TooltipArrow />
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
};
